
<template>
    <div class="pages-tables " id="pages-tables">
        <div class="waterMask" id="waterMark" :style="{height: theadHeight + 'px', top: offsetHeight + 'px'}"></div>
        <div class="rolling-table auto-table" ref="tableBox" :style="{height: maxHeight + 'px'}">
            <table v-show="isShowTable" class="table" id="table" cellpadding="0" cellspacing="0" ref="rollingTable">
                <thead ref="thead">
                    <tr v-for="(x,i) in headerList" :key="i">
                        <th class="rows " :class="{'cross': index == 0 && i == 0}" v-for="(l,index) in x" :key="index" :colspan="l.width" :rowspan="l.height">{{l.name}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(b,i) in bodyList" :key="i + 'a'">
                        <template v-for="(x, key, index) in b">
                            <td :class="{'cols':  index == 0 }" :key="key">
                                {{ x | valueFromt }}
                            </td>
                        </template>
                    </tr>
                    <tr></tr>
                </tbody>

            </table>
        </div>
    </div>
</template>
<script>
import { createIScrollerAuto, refreshScroller } from "libs/iscrollTable";
import { addWaterMarker, formatArray, getLeafCountTree } from "libs/common/common";
import commonMixin from 'mixins/common/common.js';
import { Toast, Indicator } from "mint-ui";
export default {
    mixins: [commonMixin],
    data() {
        return {
            maxHeight: '100%',
            theadHeight: '100%',
            offsetHeight: 0,
            isShowTable: false,
            scroll: {
                scroller: null
            },
            headerList: [],
            headerList1: [
                [
                    {
                        name: "第一行合并3行1列22",
                        width: 1, //指定单元格 横向 跨越的 列数
                        height: 3, //指定单元格 纵向 跨越的 行数
                    },
                    {
                        name: "第一行合并2列",
                        width: 3,
                        height: 1,
                    },
                    {
                        name: "第一行合并2列",
                        width: 2,
                        height: 1,
                    },
                    {
                        name: "第一行合并3列",
                        width: 3,
                        height: 1,
                    },
                ],
                [
                    {
                        name: "第二行日期",
                        width: 1, //指定单元格 横向 跨越的 列数
                        height: 1, //指定单元格 纵向 跨越的 行数
                    },
                    {
                        name: "第二行日期合并2列",
                        width: 2,
                        height: 1,
                    },
                    {
                        name: "第二行日期合并2列",
                        width: 2,
                        height: 1,
                    },
                    {
                        name: "第二行日期合并3列",
                        width: 3,
                        height: 1,
                    },
                ],
                [
                    {
                        name: "第三行当月新增",
                        width: 1,  //指定单元格 横向 跨越的 列数
                        height: 1, //指定单元格 纵向 跨越的 行数
                    },
                    {
                        name: "第三行当月新增1第三行",
                        width: 1,
                        height: 1,
                    },
                    {
                        name: "第三行当月新增2",
                        width: 1,
                        height: 1,
                    },
                    {
                        name: "第三行当月新增3第三行当月",
                        width: 1,
                        height: 1,
                    },
                    {
                        name: "第三行当月新增4",
                        width: 1,
                        height: 1,
                    },
                    {
                        name: "第三行当月新增5",
                        width: 1,
                        height: 1,
                    },
                    {
                        name: "第三行当月新增6",
                        width: 1,
                        height: 1,
                    },
                ],
            ],
            headerFieldList: ['statis_date', 'area_name', "area_name1", "area_name2", "area_name3", "area_name4", "area_name5", "area_name6",],
            bodyList: [],

        }
    },
    filters: {
        valueFromt: function (value) {
            let realValue = ''
            if (!value) return ''
            value = value.toString()
            if (value.length > 20) {
                realValue = value.slice(0, 15) + '...'
            } else {
                realValue = value
            }
            return realValue
        },
    },
    methods: {
        getData(date, id) {
            Indicator.open();
            this.$http.post(this.$urls.data404, {
                area_id: 0,
                // area_id: Number(id),
                // date: Number(date)
                date: 20180728
            })
                .then(res => {
                    Indicator.close();
                    if (res.data.code === 200) {
                        this.bodyList = res.data.data.body
                        const newData = formatArray(res.data.data.header, 0)
                        console.log(newData);

                        let maxLevel = newData[newData.length - 1].level
                        this.setHeight(newData, maxLevel + 1)
                        // console.log("setHeight", this.setHeight(newData, maxLevel + 1))
                        this.arayLayered(newData, maxLevel)
                        // console.log('sortAray', this.arayLayered(newData, maxLevel))

                        this.headerList = this.arayLayered(newData, maxLevel)
                        this.isShowTable = true
                        setTimeout(() => {
                            this.offsetHeight = this.$refs.thead.offsetHeight - 50
                            this.theadHeight = window.screen.height - this.offsetHeight
                            // console.log("this.$refs.thead.offsetHeight",this.$refs.thead.offsetHeight)
                            addWaterMarker(document.getElementById('waterMark'), "2018-07-30 12:00:00 xuyingbiaochen", 700, 200)
                        }, 500)
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch(error => {
                    Toast("获取数据失败");
                    Indicator.close();
                    console.log(error);
                });
        },
        setHeight(arr, maxLevel) {
            console.log("setHeight maxLevel", maxLevel)
            for (let i = maxLevel; i >= 0; i--) {
                for (let j = 0; j < arr.length; j++) {
                    // 设置高
                    if (arr[j].childrenNumber) {
                        arr[j].height = 1
                    } else {
                        arr[j].height = maxLevel - arr[j].level
                    }
                }
            }
            return arr
        },
        arayLayered(arr, maxLevel) {
            let returnArr = []
            for (let i = 0; i <= maxLevel; i++) {
                let arrLevel = []
                for (let j = 0; j < arr.length; j++) {
                    if (arr[j].level == i) {
                        arrLevel.push(arr[j])
                    }
                }
                returnArr[i] = arrLevel
            }
            return returnArr
        }
    },
    mounted() {
        let bodyListA = [
            ["地区最先", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
            ["地区最后", "数据111", "数据112", "数据121", "数据122", "数据131", "数据132", "数据14"],
        ]
        for (let i = 0; i < 5; i++) {
            this.bodyList = this.bodyList.concat(bodyListA)
        }
        // console.log('this.bodyList', this.bodyList)
        this.maxHeight = window.screen.height - (window.screen.height - window.innerHeight)
        this.scroll.scroller = createIScrollerAuto(".auto-table");

        const data = [
            {
                id: 1,
                pid: 0,
                name: '地区',
            },
            {
                id: 2,
                pid: 0,
                name: '总数据',
                children: [
                    {
                        id: 3,
                        pid: 2,
                        name: '数据1',
                        children: [
                            {
                                id: 4,
                                pid: 3,
                                name: '数据11',
                                children: [{
                                    id: 5,
                                    pid: 4,
                                    name: '数据111',
                                },
                                {
                                    id: 6,
                                    pid: 4,
                                    name: '数据112',
                                }
                                ]
                            },
                            {
                                id: 7,
                                pid: 3,
                                name: '数据12',
                                children: [{
                                    id: 8,
                                    pid: 7,
                                    name: '数据121',
                                },
                                {
                                    id: 9,
                                    pid: 7,
                                    name: '数据122',
                                }
                                ]
                            },
                            {
                                id: 10,
                                pid: 3,
                                name: '数据13',
                                children: [{
                                    id: 11,
                                    pid: 10,
                                    name: '数据131',
                                },
                                {
                                    id: 12,
                                    pid: 10,
                                    name: '数据132',
                                }
                                ]
                            },
                            {
                                id: 13,
                                pid: 3,
                                name: '数据14',
                            },
                        ]
                    }
                ]
            }
        ];



        this.setTitle({ 'title': '复杂表格' });
        this.getData()
    }
}

</script>
<style lang="less" scoped>
.waterMask {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 4;
    pointer-events: none;
}
.pages-tables {
  -webkit-overflow-scrolling: touch; // ios滑动顺畅
  position: relative;
}
.rolling-table {
    height: 100%;
    font-size: 0.28rem;
    color: #86939a;
    background-color: #fff;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    position: relative;
    top: 0;
    overflow: hidden;
  }
.rows {
    position: relative;
    z-index: 3;
}
.cross {
    position: relative;
    z-index: 5;
}
table td {
  border: 0px solid #000;
  font-size: 0.32rem;
  background: #fff;
}
::-webkit-scrollbar {
    display: none;
}
.table {
//   border-collapse: collapse; //去掉重复的border
  color: #86939e;
  font-size: 0.32rem;
  border: 0px solid #000;
  min-height: 100%;
  text-align: center;
  td {
    border-bottom: 0.02rem solid #eee;
    height: 0.86rem;
    line-height: 0.86rem;
    padding: 0 0.2rem;
    // white-space: nowrap;
    white-space: inherit;
    max-width: 4rem;
    min-width: 2rem;
    // overflow:hidden; 
    // text-overflow:ellipsis;
    // -webkit-line-clamp:2; 
  }
  th {
    color: #43484d;
    // white-space: nowrap;
    white-space: inherit;
    max-width: 4rem;
    // min-width: 1rem;
    height: 0.74rem;
    line-height: 0.74rem;
    padding: 0rem 0.3rem;
    background-color: #f3f4f6;
    font-weight: normal;
    padding-bottom: 0;
    padding-top: 0;
    border-right: 0.02rem solid #eee;
    border-bottom: 0.02rem solid #eee;
    &:last-child{
        // border-right: 0rem solid #e4e8f5;
    }
  }
}
tr{
    position: relative;
    background-color: #fff;
    &:nth-of-type(odd){
        td{
            background-color: #ebf9fc;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/app/table.vue